const baseCommonApiUrl = '/api/Common';

export const COMMON_API_URLS = {
  ActionStatusList: `${baseCommonApiUrl}/ActionStatusList`,
  ActionTaskTypeList: `${baseCommonApiUrl}/ActionTaskTypeList`,
  ActionTypeList: `${baseCommonApiUrl}/ActionTypeList`,
  DealStatusList: `${baseCommonApiUrl}/DealStatusList`,
  LeadTypeList: `${baseCommonApiUrl}/LeadTypeList`,
  ServiceTypeList: `${baseCommonApiUrl}/ServiceTypeList`,
  SupportiveRegions: `${baseCommonApiUrl}/SupportiveRegions`,
  Regions: `${baseCommonApiUrl}/Regions`,
  SiteRegionAutoDetect: `${baseCommonApiUrl}/SiteRegionAutoDetect`,
  VendorTypes: `${baseCommonApiUrl}/VendorTypes`,
  Industries: `${baseCommonApiUrl}/Industries`,
  ClientStatus: `${baseCommonApiUrl}/ClientStatus`,
  FranchiseOffices: `${baseCommonApiUrl}/FranchiseOffices`,
  SLAStatusList: `${baseCommonApiUrl}/SLAStatusList`,
  CrmTrainingArticle: `${baseCommonApiUrl}/crm-training-article`,
  Users: (userName?: string, usersCount?: number) =>
    `${baseCommonApiUrl}/users?userName=${userName}&usersCount=${usersCount}`,
  ImperansCompanies: (search?: string, count?: number) =>
    `${baseCommonApiUrl}/impernas/companies?searchQuery=${search}&count=${count}`,
};
